"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateListPaginatedApiOptions = void 0;
const bad_request_1 = require("../errors/bad-request");
const validateListPaginatedApiOptions = (options) => {
    if (options.limit < 1 || options.limit > 1000) {
        throw new bad_request_1.BadRequest("Invalid limit parameter, please provide a value from 1 to 1000");
    }
};
exports.validateListPaginatedApiOptions = validateListPaginatedApiOptions;
